document.addEventListener( 'DOMContentLoaded', () => {
	class TFOIFA {
		static CLASS_NAME_TFOIFA_BLOCK = 'jtf__tfoifablock'
		static CLASS_NAME_CLEAR = 'jtf__tfoifablock--clear'
		static CLASS_NAME_INPUT = 'jtf__tfoifablock--input'
		static CLASS_NAME_BUTTONS_IFA = 'jtf__tfoifablock--buttons-ifa'
		static CLASS_NAME_BUTTON_IFA = 'jtf__tfoifablock--externalbutton-ifa'
		static CLASS_NAME_BUTTONS_AAS = 'jtf__tfoifablock--buttons-aims_and_scope'
		static CLASS_NAME_BUTTON_AAS = 'jtf__tfoifablock--externalbutton-aas'
		static CLASS_NAME_COUNT = 'jtf__tfoifablock--count'
		static SELECTOR_CLASS_WP_ADMIN = '.wp-admin'
		static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-tfoifa'
		static ATTR_DATA_ID = 'data-id'
		static ATTR_DATA_ACR = 'data-acr'
		static ATTR_DATA_APC = 'data-apc'
		static ATTR_DATA_TFO = 'data-tfo'
		static ATTR_HREF = 'href'
		static PROP_APC_YES_IN_DOVE = 'yes_in_dove'
		static PROP_APC_YES_IN_API_DOVE = 'yes_in_api_dove'
		static PROP_APC_NO_DOVE = 'no_dove'
		static TIMEOUT_DELAY = 1000
		static DOVE_BASE_URL = 'https://www.dovepress.com/'
		static DOVE_JOURNAL_SUFFIX = '-journal'

		constructor( instance ) {
			this.instance = instance
			this.classTfoIfaBlock = TFOIFA.CLASS_NAME_TFOIFA_BLOCK
			this.instanceId = 0
			this.init()
		}

		constructButtonHref( acronym, apc, title, button ) {
			let href
			switch ( apc ) {
				case TFOIFA.PROP_APC_YES_IN_DOVE:
				case TFOIFA.PROP_APC_YES_IN_API_DOVE:
				case TFOIFA.PROP_APC_NO_DOVE: {
					let processed_title = title
					.toLowerCase()
					.replace( /[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '' )
					.replace( / /g, '-' )

					href = TFOIFA.DOVE_BASE_URL + processed_title + TFOIFA.DOVE_JOURNAL_SUFFIX
					break
				}
				default: {
					href = button.getAttribute( TFOIFA.ATTR_DATA_TFO )
					href += acronym
					break
				}
			}
			return href
		}

		fadeIn( element ) {
			element.style.display = 'inline-block'
			element.style.opacity = '0'
			element.style.transition = 'opacity 0.4s'
			setTimeout( () => {
				element.style.opacity = '1'
			}, 10 )
		}

		fadeOut( element ) {
			element.style.opacity = '1'
			element.style.transition = 'opacity 0.4s'
			setTimeout( () => {
				element.style.opacity = '0'
				// noinspection MagicNumberJS
				setTimeout( () => {
					element.style.display = 'none'
				}, 400 )
			}, 10 )
		}

		init() {
			const blockEl = this.instance.querySelector( '.' + this.classTfoIfaBlock )
			if ( blockEl ) {
				this.instanceId = blockEl.getAttribute( TFOIFA.ATTR_DATA_ID )
			}

			this.instance.addEventListener( 'click', ( e ) => {
				const clearBtn = e.target.closest( '.' + TFOIFA.CLASS_NAME_CLEAR )
				if ( clearBtn ) {
					e.preventDefault()

					const input = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_INPUT )
					if ( input ) {
						input.value = ''
					}

					const ifaButtonsContainer = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_BUTTONS_IFA )
					if ( ifaButtonsContainer ) {
						const ifaButton = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_BUTTON_IFA )
						if ( ifaButton ) {
							this.fadeOut( ifaButton )
						}
					}

					const aasButtonsContainer = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_BUTTONS_AAS )
					if ( aasButtonsContainer ) {
						const aasbutton = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_BUTTON_AAS )
						if ( aasbutton ) {
							this.fadeOut( aasbutton )
						}
					}
				}
			} )

			this.instance.addEventListener( 'change', ( e ) => {
				const input = e.target.closest( '.' + TFOIFA.CLASS_NAME_INPUT )
				if ( input ) {
					const title = input.value
					const datalistId = 'journals-' + this.instanceId
					const datalist = document.getElementById( datalistId )

					if ( datalist ) {
						const options = Array.from( datalist.querySelectorAll( 'option' ) )
						const matchedOption = options.find( ( option ) => {
							return option.value === title
						} )

						if ( matchedOption ) {
							const acronym = matchedOption.getAttribute( TFOIFA.ATTR_DATA_ACR )
							const apc = matchedOption.getAttribute( TFOIFA.ATTR_DATA_APC )

							e.preventDefault()
							e.stopPropagation()

							const ifaButtonsContainer = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_BUTTONS_IFA )
							if ( ifaButtonsContainer ) {
								const ifaButton = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_BUTTON_IFA )
								if ( ifaButton ) {
									this.fadeIn( ifaButton )
									const href = this.constructButtonHref( acronym, apc, title, ifaButton )
									ifaButton.setAttribute( TFOIFA.ATTR_HREF, href )
								}
							}

							const aasButtonsContainer = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_BUTTONS_AAS )
							if ( aasButtonsContainer ) {
								const aasbutton = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_BUTTON_AAS )
								if ( aasbutton ) {
									this.fadeIn( aasbutton )
									const href = this.constructButtonHref( acronym, apc, title, aasbutton )
									aasbutton.setAttribute( TFOIFA.ATTR_HREF, href )
								}
							}

							const countSpan = this.instance.querySelector( '.' + TFOIFA.CLASS_NAME_COUNT + ' span' )
							if ( countSpan ) {
								countSpan.innerHTML = '1'
							}
						}
					}
				}
			} )
		}
	}

	const wpAdmin = document.querySelector( TFOIFA.SELECTOR_CLASS_WP_ADMIN )
	if ( wpAdmin ) {
		setTimeout( () => {
			const blocks = document.querySelectorAll( TFOIFA.SELECTOR_CLASS_BLOCK )
			if ( blocks.length > 0 ) {
				blocks.forEach( ( block ) => {
					new TFOIFA( block )
				} )
			}
		}, TFOIFA.TIMEOUT_DELAY )
	} else {
		const blocks = document.querySelectorAll( TFOIFA.SELECTOR_CLASS_BLOCK )
		if ( blocks.length > 0 ) {
			blocks.forEach( ( block ) => {
				new TFOIFA( block )
			} )
		}
	}
} )
